import { Dashboard } from "./icons";

export const UserMenus = [
  {
    label: "Dashboard",
    key: "dashboard",
    icon: "ki-outline ki-element-11",
  },
  {
    label: "Alerts",
    key: "alerts",
    icon: "ki-outline ki-notification-on",
  },
  {
    label: "Settings",
    key: "settings",
    icon: "ki-outline ki-gear",
    children: [
      {
        key: "settings/products",
        label: "Products",
        icon: "ki-outline ki-directbox-default"
      },
      {
        key: "settings/expenses",
        label: "Expenses",
        icon: "ki-outline ki-finance-calculator"
      },
      {
        key: "settings/myprofile",
        label: "My Profile",
        icon: "ki-outline ki-user"
      },
      {
        key: "settings/marketplace-credentials",
        label: "Marketplace Credentials",
        icon: "ki-outline ki-lock"
      }
    ],
  },
];
